import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { postCoreDataSecurityAccessLogExportSlice } from './post';

export const coreDataSecurityAccessLogExportReducers = combineReducers({
	post: postCoreDataSecurityAccessLogExportSlice.asyncReducers
});

export const coreDataSecurityAccessLogExportWatchers = combineAllWatchers([
	postCoreDataSecurityAccessLogExportSlice.asyncWatchers
]);
